<mat-chip
    [disabled]="!isMostRecentFilter && addedFilterLength > 1"
    [ngClass]="{ disabled: !isMostRecentFilter && addedFilterLength > 1 }"
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="selectionMenu">
    <mat-icon class="remove_filter_icon" matChipRemove (click)="removeFilter()"
        >cancel
    </mat-icon>
    <ng-container *ngIf="selectedOptions.length > 0; else defaultLabel">
        <div
            class="selected-option-heading"
            *ngFor="let option of selectedOptions | slice : 0 : 1">
            {{ option.heading }}
        </div>
        <div
            class="selected-option-heading"
            *ngFor="let option of selectedOptions | slice : 1">
            {{ option.heading }}
        </div>
    </ng-container>
    <ng-template #defaultLabel>
        {{ filter.name }}
    </ng-template>

    <mat-icon class="toolbar_icon_colour"> arrow_drop_down </mat-icon>
</mat-chip>

<mat-menu
    (click)="$event.stopPropagation()"
    #selectionMenu="matMenu"
    #matMenu="matMenu"
    class="combination-menu">
    <form [formGroup]="form">
        <div class="select-wrapper">
            <mat-form-field
                (click)="$event.stopPropagation()"
                appearance="outline"
                *ngFor="let i of filter.extraFilters">
                <mat-label>{{ i.name }}</mat-label>
                <mat-select
                    [formControlName]="i.field"
                    (click)="$event.stopPropagation()">
                    <mat-option
                        (click)="selectOption(i, option)"
                        *ngFor="let option of i.options"
                        [value]="option">
                        <ng-container
                            [ngSwitch]="
                                option.filterOptionType ==
                                dataTypeEnum.HeadingOnly
                            ">
                            {{ option.heading }}
                        </ng-container>
                    </mat-option>
                    <mat-option disabled *ngIf="!filter.extraFilters.length">
                        No options available
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
</mat-menu>
